import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import search from '../../../assets/images/search.png'
import useClickOutside from "../../../useClickOutside";

const pages = [
    { id: 1, path: '/', title: 'Home' },
    { id: 2, path: '/visitors', title: 'Visitors' },
    { id: 3, path: '/project-request', title: 'Project Requests' },
    { id: 4, path: '/project-types', title: 'Project Types' },
    { id: 5, path: '/users', title: 'Users' },
    { id: 6, path: '/roles', title: 'Roles' },
    { id: 7, path: '/evaluation-types', title: 'Evaluation Types' },
    { id: 8, path: '/settings', title: 'Settings' },
    { id: 9, path: '/notifications', title: 'Notifications' },
];

function SearchBar() {
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();

    const [langPop, setlangPop] = useState(false);
    
    let domNode = useClickOutside(() => {
        setlangPop(false);
    });

    useEffect(() => {
        // Filter pages that contain a title matching the search term
        const filteredSuggestions = pages.filter(
            page => page.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const limitedSuggestions = filteredSuggestions.slice(0, 3);
        if (searchTerm == '') {
            setSuggestions([]);
        } else {
            setSuggestions(limitedSuggestions);
        }
    }, [searchTerm]);


    const handleSearch = (page) => {
        navigate(page.path);
        setSearchTerm('');
        setlangPop(false);
    };

    const handleInput = (value) => {
        setSearchTerm(value);
        setlangPop(true);
    };

    return (
        <div className='search_cat' ref={domNode}>
            {langPop && (
                <ul>
                    {searchTerm !== '' && suggestions.length === 0 && (
                        <li style={{marginBottom: '0px'}} >No results found</li>
                    )}
                    {suggestions.map(page => (
                        <li key={page.id} onClick={() => handleSearch(page)}>
                            {page.title}
                        </li>
                    ))}
                </ul>
            )}
            <input
                type="text"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => handleInput(e.target.value)}
            />

            <i className='fa fa-search' ></i>

        </div>
    );
}

export default SearchBar;
